/**
* 分页组件
*/ 
<template>
  <el-pagination
    class="page-box"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    background
    :current-page="childMsg.currentPage"
    :page-size="childMsg.pageSize"
    :page-sizes="childMsg.pageSizes || [childMsg.pageSize]"
    :layout="childMsg.pageSizes ? 'total, sizes, prev, pager, next, jumper' : 'total, prev, pager, next, jumper'"
    :total="childMsg.total">
  </el-pagination>


      <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="childMsg.currentPage"
      :page-size="20"
      layout="total, prev, pager, next"
      :total="childMsg.total">
    </el-pagination> -->


</template>
<script>
export default {
  name: 'Pagination',
  props: ['childMsg'],
  data() {
    return {
      pageparm: {
        currentPage: this.childMsg.currentPage,
        pageSize: this.childMsg.pageSize
      }
    }
  },
  created() {},
  methods: {
    handleSizeChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.pageparm.pageSize = val
      this.pageparm.currentPage = 1
      this.$emit('callFather', this.pageparm)
    },
    handleCurrentChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.pageparm.currentPage = val
      this.$emit('callFather', this.pageparm)
    }
  }
}
</script>

<style>
.page-box {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue